import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import Tr from "translations/Translations";
import {makeStyles} from "@material-ui/core/styles";
import {TextField} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import GridBlock from "components/GridBlock";
import IconButton from "components/button/IconButton";
import WorkableIconButton from "components/button/WorkableIconButton";
import clsx from "clsx";
import {useDidUpdateEffect} from "../hooks/useDidUpdateEffect";

const useStyle = makeStyles(theme => ({
    root: {

        '&>*:not(:first-child):not(:last-child)': {
            marginLeft: theme.spacing(4),
        }
    },
    search: {
        width: 400,
    }
}));

const EMPTY_SEARCH_OBJECT = {search: ''}
const MAX_SEARCH_LENGTH = 100;

function BasicSearch(
    {
        className,
        label,
        searchInProgress,
        doSearch,
        clearSearch
    }) {


    const getInitValue = () => {
        return {...EMPTY_SEARCH_OBJECT};
    }

    const classes = useStyle();
    const [value, setValue] = useState(getInitValue());
    const [submitState, setSubmitState] = useState(0);

    useEffect(() => {
        if (submitState && !searchInProgress) {
            const valueFiltered = Object.keys(value)
                .filter((k) => value[k])
                .reduce((a, k) => ({...a, [k]: value[k]}), {});
            doSearch(valueFiltered);
        }
        // eslint-disable-next-line
    }, [submitState]);

    useDidUpdateEffect(() => {
        doClearSearch();
    },[clearSearch]);

    const handleChange = (id, e) => {
        setValue({...value, [id]: e.target.value});
    }

    const handleSubmit = () => {
        setSubmitState(x => x + 1)
    };

    const doClearSearch = () => {
        setValue(EMPTY_SEARCH_OBJECT);
        handleSubmit()
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSubmit()
        }
    };

    return (
        <>
            <GridBlock className={clsx(classes.root, className)}>

                <TextField
                    className={classes.search}
                    label={label}
                    onChange={e => handleChange('search', e)}
                    onKeyUp={handleKeyPress}
                    fullWidth
                    value={value.search}
                    inputProps={{maxLength: MAX_SEARCH_LENGTH}}
                />

                <div>
                    <WorkableIconButton Icon={SearchIcon} working={searchInProgress} onClick={handleSubmit} tooltip={Tr('search')}/>
                    <IconButton disabled={searchInProgress} Icon={ClearIcon} tooltip={Tr('clear')} onClick={doClearSearch}/>
                </div>
            </GridBlock>
        </>
    )
}

BasicSearch.propTypes = {
    classes: PropTypes.any,
    className: PropTypes.string,
    label: PropTypes.string,
    searchInProgress:PropTypes.bool,
    doSearch: PropTypes.func.isRequired,
    clearSearch: PropTypes.any
}


export default BasicSearch;